import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserOne } from '@models/userone';
import { Country } from '@models/country';
import { State } from '@models/state';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-personal-info-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './app-personal-info-form.component.html',
  styleUrl: './app-personal-info-form.component.css'
})
export class AppPersonalInfoFormComponent {
  @Input() user: UserOne;
  @Input() editMode: boolean = false;
  @Input() userProfForm: FormGroup;
  @Input() countries: Country[] = [];
  @Input() states: State[] = [];
  @Input() isUSSelected: boolean = false;
  @Output() saveChanges = new EventEmitter<void>();
  @Output() editModeChange = new EventEmitter<boolean>();

  onSubmit(): void {
    if (this.userProfForm?.valid) {
      // console.log('Form Submitted', 'alter user form');
      this.saveChanges.emit();
    }
    // console.log('Form Not Valid Submitted', 'alter user form');
  }

  onCancel(): void {
    this.editMode = false;
    this.editModeChange.emit(this.editMode);
  }

  // Dynamic placeholder methods
  getStatePlaceholder(): string {
    if (this.user?.state) {
      // User has a state value, show "Select State" as they might want to change it
      return 'Select State (optional)';
    } else {
      // User has no state value, show instruction
      return this.isUSSelected ? 'Select State (optional)' : 'Enter state/province (optional)';
    }
  }

  getCountryPlaceholder(): string {
    if (this.user?.countryId) {
      // User has a country, show "Select Country" as they might want to change it
      return 'Select Country';
    } else {
      // User has no country, show instruction
      return 'Select Country';
    }
  }
}
